export const LAST_DRAMA_KEY = 'drama:last-played'
export function recentDramaId(): string | null {
  try {
    const data = JSON.parse(localStorage.getItem(LAST_DRAMA_KEY) || 'null')
    return typeof data?.contentId === 'string' && Number.isFinite(data.playedAt) ? data.contentId : null
  }
  catch { return null }
}
